import React, {
  useEffect,
  useState,
  CSSProperties,
  SetStateAction,
} from "react";
// import { , ReactElement, useMemo, useState } from "react";
import {
  TableContainer,
  Table,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
  Paper,
  Box,
  Typography,
  IconButton,
  Avatar,
  Checkbox,
  SxProps,
  Theme,
  SelectChangeEvent,
  Tooltip,
  List,
  ListItem,
  TablePagination,
  Card,
  CardContent,
} from "@mui/material";
import CustomButton from "../../common/CustomButton/CustomButton";
import clockIcon from "../../assets/svgs/clock-icon.svg";
import menuIcon from "../../assets/svgs/menu-icon.svg";
import { AgentCustomTableStyles } from "./AgentCustomTableStyles";
import highIcon from "../../assets/svgs/high.svg";
import mediumIcon from "../../assets/svgs/medium.svg";
import lowIcon from "../../assets/svgs/low.svg";
import infoIcon from "../../assets/svgs/info-icon.svg";
import renewalIcon from "../../assets/svgs/renewal-icon.svg";
import cancelIcon from "../../assets/svgs/cancelled-icon.svg";
import overdueIcon from "../../assets/svgs/overdue-icon.svg";
import activeIcon from "../../assets/svgs/active-icon.svg";
import pendingIcon from "../../assets/svgs/pending-icon.svg";
import sortIcon from "../../assets/svgs/sorting-icon.svg";
import docIcon from "../../assets/svgs/document-icon.svg";
import downloadIcon from "../../assets/svgs/download-icon.svg";
import descendingSort from "../../assets/svgs/decending-sort.svg";
import inProgress from "../../assets/svgs/in-progress.svg";
import phoneIcon from "../../assets/svgs/phone-icon.svg";
import mailIcon from "../../assets/svgs/mail-icon.svg";
import {
  ACTIVE,
  CLAIMS,
  CLAIM_STATUS,
  CLOSED,
  CONTACT_DETAILS,
  CUSTOMER_DETAILS,
  CUSTOMER_POLICY_STATUS,
  EXPIRED,
  HIGH_PRIORITY,
  INFO_ICON,
  LOW_PRIORITY,
  MEDIUM_PRIORITY,
  MENU_ICON,
  NO_DATA_AVAILABLE,
  OVERDUE,
  OVERDUE_CAPS,
  OPEN,
  PENDING_RENEWAL,
  POLICY_DETAILS,
  POLICY_STATUS,
  POLICY_TYPE,
  RENEWAL,
  ACTIVE_CAPS,
  DUE_RENEWAL,
  CANCELLED,
  CANCELLED_CAPS,
  CUSTOMER_STATUS,
  SORT_ICON,
  DETAILS,
  DOWNLOAD,
  PAY_NOW,
  COMMISSION_STATUS,
  TASKS,
  TASK,
  PENDING,
  ACTIVE_LOWER,
  POLICY_LOWER,
  STATUS_LOWER,
  CLIENT_NAME_LOWER,
  PRIORITY_LOWER,
  TASK_DATE_LOWER,
  TASK_LOWER,
  COMMISSION_POLICY_DETAILS,
  COMMISSION_CUSTOMER_DETAILS,
  FOLDER_NAME,
  FILE_NAME,
  NOTES,
  ARCHIVE_FILE,
  ARE_YOU_SURE_ARCHIVE,
  FILE_LOWER,
  CANCEL,
  FOLDER_LOWER,
  ARCHIVING_THE_FOLDER,
  ADD_TASK,
  CLIENT_DETAILS_LOWER,
  FILTER,
  NO_POLICIES_AVAILABLE,
} from "../../constants";
import CustomTooltip, {
  StyledListItemText,
} from "../../common/Tooltip/Tooltip";
import ImageAndText from "../ImageAndText/ImageAndText";
import paynowIcon from "../../assets/svgs/paynow-icon.svg";
import stringAvatar from "../../utils/StringAvatar";
import { useNavigate } from "react-router-dom";
import { myTasksTooltip } from "../../constants/TootipData";
import { personData } from "../../constants/myTasksPersonData";
import { personChat } from "../../constants/myTasksPersonChatData";
import Drawers from "../Drawers/Drawers";
import Notes from "../Notes/Notes";
import CustomIcon from "../../common/CustomIcon/CustomIcon";
import styled from "@emotion/styled";
import ModalComponent from "../../common/ModalComponent/ModalComponent";
import reScheduleIcon from "../../assets/svgs/re-schedule.svg";
import { customerDetailsOverviewOptions } from "../../constants/CustomerDetailsOverviewOptions";
import SendRemainder from "../SendRemainder/SendRemainder";
import { sendRemaindersAndShareMarketData } from "../../constants/SendRemaindersAndShareMarketData";
import NewTask from "../NewTask/NewTask";
import { Dispatch } from "@reduxjs/toolkit";
import { rowsPerPageOptions } from "../../constants/Constants";
import { useAppSelector } from "../../store/hooks";
import { RootState } from "../../store/store";
import { PolicyListingStyles } from "../PolicyListing/PolicyListingStyles";
import filterIcon from "../../assets/svgs/filter-icon.svg";
import FilterPopUp from "../FilterPopUp/FilterPopUp";
import { filterPopUpCommonOptions } from "../../constants/FilterPopUpCommonOptions";

interface IColumns {
  label: string;
  accessorKey?: string;
  additionalOptions?: string;
  tableHeaderCells?: CSSProperties;
  tBodyCellCss?: CSSProperties;
  Cell?: <T>(item: T) => void;
}

interface DataTableProps {
  data: any[];
  headerData: IColumns[];
  type?:
    | "default"
    | "primary"
    | "secondary"
    | "customerPolicies"
    | "customerListing"
    | "myTasksTable"
    | "overviewTable"
    | "invoicesTable"
    | "commissionStatements"
    | "nohover"
    | "documentListingList"
    | "policyListing";
  onhandleDateClick?: () => void;
  primary?: boolean;
  additionaltableContainer?: SxProps<Theme>;
  handleRowClick?: (
    id: string,
    lobCode?: string | null,
    customerId?: string | null
  ) => void;
  requestFrom?: string;
  policiesPerPage: string;
  setPoliciesPerPage: Dispatch<SetStateAction<any>>;
  totalPolicies: number;
  setContinuationId?: Dispatch<SetStateAction<any>>;
  setPrevId?: Dispatch<SetStateAction<any>>;
  showFilters?: boolean;
  statusCode?: string;
  // selectedKey?: string;
}
const StyledCustomerDetailsAvatar = styled(Box)({
  "& .MuiAvatar-root": {
    width: "32px",
    height: "32px",
    border: "1px solid var(--primary-grey)",
  },
});
const StyledCheckbox = styled(Checkbox)({
  color: "var(--black)",
  padding: "0px",
  width: "16px",
  "& .MuiSvgIcon-root": {
    fontSize: "17px",
  },
});
const AgentCustomTable: React.FC<DataTableProps> = ({
  data,
  headerData,
  type = "default",
  onhandleDateClick,
  primary = false,
  additionaltableContainer,
  handleRowClick,
  requestFrom,
  policiesPerPage,
  setPoliciesPerPage,
  totalPolicies,
  setContinuationId,
  setPrevId,
  showFilters,
  statusCode,
}) => {
  const navigate = useNavigate();
  const [hoveredRow, setHoveredRow] = useState<number | null>(null);
  const [checkedItems, setCheckedItems] = useState<number[]>([]);
  const [openTooltipRow, setOpenTooltipRow] = useState<number | null>(null);
  const [toolTipIndex, setToolTipIndex] = useState<number | null>(null);
  const [notesOpen, setNotesOpen] = useState(false);
  const [sortOrder, setSortOrder] = useState<Record<number, boolean>>({});
  const [modalOpen, setModalOpen] = useState(false);
  const [fileName, setFileName] = useState("");
  const [isFolder, setIsFolder] = useState(false);
  const [drawerOpen, setDrawerOpen] = useState(false);
  const [selectedDropdownValue, setSelectedDropdownValue] = useState("");
  const [tasksOpen, setTasksOpen] = useState(false);
  const [activeTooltip, setActiveTooltip] = useState<number | null>(null);
  const [nonPayRowsPerPage, setNonPayRowsPerPage] = useState<number>(5);

  const [page, setPage] = useState(0);
  const { nextContinuationId, prevContinuationId, currentContinuationId } =
    useAppSelector((state: RootState) => state.agentPolicies);
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const [selectedFilter, setSelectedFilter] = useState("");
  const open = Boolean(anchorEl);

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleSelect = (key: string) => {
    setSelectedFilter(key);
    handleClose();
  };

  //   useEffect(() => {
  //     setOpenTooltipRow(null);
  //     setToolTipIndex(null);
  //   }, [hoveredRow, notesOpen, modalOpen, tasksOpen, activeTooltip]);

  //   useEffect(() => {
  //     if (openTooltipRow !== null) {
  //       const rowData = data[openTooltipRow];
  //       const nameToSet = rowData.fileName || rowData.folderName;
  //       setIsFolder(!!rowData.folderName);
  //       setFileName(nameToSet);
  //     }
  //   }, [openTooltipRow]);

  useEffect(() => {
    setPage(0);
  }, [statusCode]);

  const handleDetailsToolTipOpen = (index: number | null) => {
    setActiveTooltip((prevIndex) => (prevIndex === index ? null : index));
  };

  const handleDetailsToolTipClose = () => {
    setActiveTooltip(null);
  };
  if (!data || data.length === 0) {
    return (
      <Card sx={AgentCustomTableStyles.noPoliciesAvailable}>
        <CardContent>
          <Typography variant="h6">{NO_POLICIES_AVAILABLE}</Typography>
        </CardContent>
      </Card>
    );
  }
  const drawerOptions = [
    { value: "View", key: "view" },
    { value: "Edit", key: "edit" },
    { value: "Move", key: "move" },
    { value: "Archive", key: "archive" },
  ];

  const headers = headerData?.length === 0 ? data[0] : headerData;
  const renderCellContent = (key: string, value: any, rowIndex: any) => {
    switch (key) {
      case TASK_DATE_LOWER:
        return (
          <CustomButton
            onClick={onhandleDateClick}
            additionalContainerClassName={
              AgentCustomTableStyles.dateButtonContainer
            }
            additionalClassName={AgentCustomTableStyles.dateButton}
            text={value.date + "," + value.time}
            type="grey-outlined"
          />
        );
      case PRIORITY_LOWER:
        let priorityText = "";
        let priorityImg = null;

        if (value.toLowerCase() === "high") {
          priorityText = HIGH_PRIORITY;
          priorityImg = highIcon;
        } else if (value.toLowerCase() === "medium") {
          priorityText = MEDIUM_PRIORITY;
          priorityImg = mediumIcon;
        } else if (value.toLowerCase() === "low") {
          priorityText = LOW_PRIORITY;
          priorityImg = lowIcon;
        }

        return (
          <Box sx={AgentCustomTableStyles.priorityContainer}>
            {priorityImg && <img src={priorityImg} alt={priorityText} />}
            <Typography sx={AgentCustomTableStyles.priorityText}>
              {priorityText}
            </Typography>
          </Box>
        );
      case CLIENT_DETAILS_LOWER:
        return (
          <Box sx={AgentCustomTableStyles.clientInfoContainer}>
            <Typography sx={AgentCustomTableStyles.clientName}>
              {value.clientName}
            </Typography>

            <Tooltip
              arrow
              placement="right"
              open={activeTooltip === rowIndex}
              onClose={handleDetailsToolTipClose}
              componentsProps={{
                tooltip: {
                  sx: {
                    background: "var( --white)",
                    border: "1px solid #CFD4E1",
                    color: "var( --black)",
                  },
                },
                arrow: {
                  sx: {
                    color: "var( --white)",
                    position: "relative",
                    "&::before": {
                      border: "1px solid #CFD4E1",
                      margin: "-1px",
                    },
                  },
                },
              }}
              title={
                <List>
                  <ListItem button>
                    <StyledListItemText>
                      <ImageAndText image={mailIcon} text={value.clientEmail} />
                    </StyledListItemText>
                  </ListItem>
                  <ListItem button>
                    <StyledListItemText>
                      <ImageAndText
                        image={phoneIcon}
                        text={value.clientPhone}
                      />
                    </StyledListItemText>
                  </ListItem>
                </List>
              }
            >
              <IconButton onClick={() => handleDetailsToolTipOpen(rowIndex)}>
                <img src={infoIcon} alt={INFO_ICON} />
              </IconButton>
            </Tooltip>
          </Box>
        );
      case POLICY_LOWER:
        return (
          <Typography
            sx={AgentCustomTableStyles.policyText}
            onClick={() => navigate("/agent/policyDetails")}
          >
            {value}
          </Typography>
        );
      case STATUS_LOWER:
        const renderStatus = (status: string) => {
          let statusImage = "";
          let statusText = "";
          if (status.toLowerCase() === "pending") {
            statusImage = clockIcon;
            statusText = "Pending";
          }
          if (status.toLowerCase() === "active") {
            statusImage = activeIcon;
            statusText = "Active";
          }
          if (status.toLowerCase() === "in progress") {
            statusImage = inProgress;
            statusText = "In Progress";
          }
          if (status.toLowerCase() === "rescheduled") {
            statusImage = reScheduleIcon;
            statusText = "Rescheduled";
          }
          return (
            <ImageAndText
              additionalClassName={AgentCustomTableStyles.statusContainer}
              image={statusImage}
              text={statusText}
            />
          );
        };
        return renderStatus(value);
      case CUSTOMER_STATUS:
        let customerStatusImg = "";
        let customerStatusText = "";
        if (value.toLowerCase() === ACTIVE_LOWER) {
          customerStatusImg = activeIcon;
          customerStatusText = ACTIVE_CAPS;
        } else if (value.toLowerCase() === RENEWAL) {
          customerStatusImg = renewalIcon;
          customerStatusText = DUE_RENEWAL;
        } else if (value.toLowerCase() === OVERDUE) {
          customerStatusImg = overdueIcon;
          customerStatusText = OVERDUE_CAPS;
        } else if (value.toLowerCase() === CANCELLED) {
          customerStatusImg = cancelIcon;
          customerStatusText = CANCELLED_CAPS;
        }

        return (
          <ImageAndText
            imageClassName={AgentCustomTableStyles.customerStatusImg}
            additionalClassName={AgentCustomTableStyles.customerStatusContainer}
            image={customerStatusImg}
            text={customerStatusText}
          />
        );
      case POLICY_DETAILS:
        return (
          <Box sx={AgentCustomTableStyles.policyDetails}>
            <Typography
              onClick={() => navigate("/agent/policyDetails")}
              sx={AgentCustomTableStyles.policyNumber}
            >
              {value.policyNumber}
            </Typography>
            <Typography sx={AgentCustomTableStyles.policyTypeNumber}>
              {value.policyTypeNumber}
            </Typography>
          </Box>
        );
      case POLICY_STATUS:
        let policyStatus = "";
        let policyStatusImg = null;

        if (value.toLowerCase() === "pending") {
          policyStatus = PENDING_RENEWAL;
          policyStatusImg = pendingIcon;
        } else if (value.toLowerCase() === "active") {
          policyStatus = ACTIVE;
          policyStatusImg = activeIcon;
        }

        return (
          <ImageAndText
            imageClassName={AgentCustomTableStyles.policyStatusImg}
            image={policyStatusImg}
            text={policyStatus}
          />
        );
      case POLICY_TYPE:
        let policyTypeImage = "";
        if (value.toLowerCase() === "house") {
          policyTypeImage = "House";
        } else if (value.toLowerCase() === "auto") {
          policyTypeImage = "Auto";
        }
        return (
          <Box sx={AgentCustomTableStyles.policyType}>
            {policyTypeImage && <CustomIcon iconName={policyTypeImage} />}
          </Box>
        );
      case CUSTOMER_DETAILS:
        return (
          <Box sx={AgentCustomTableStyles.customerDetailsContainer}>
            <StyledCustomerDetailsAvatar>
              {value.image.length === 0 ? (
                <Avatar {...stringAvatar(value.customerName)} />
              ) : (
                <Avatar src={value.image} />
              )}
            </StyledCustomerDetailsAvatar>
            <Box>
              <Typography sx={AgentCustomTableStyles.customerName}>
                {value.customerName}
              </Typography>
              <Typography sx={AgentCustomTableStyles.customerNumber}>
                {value.customerNumber}
              </Typography>
            </Box>
          </Box>
        );
      case CONTACT_DETAILS:
        return (
          <Box sx={AgentCustomTableStyles.contactDetailsContainer}>
            <Typography sx={AgentCustomTableStyles.customerPhoneNumber}>
              {value.customerPhoneNumber}
            </Typography>
            <Typography sx={AgentCustomTableStyles.customerEmail}>
              {value.customerEmail}
            </Typography>
          </Box>
        );
      case CUSTOMER_POLICY_STATUS: {
        const { active, pending, expired, tasks } = value;
        let statusMessage = "";
        let tasksMessage = "";
        if (active > 0) {
          statusMessage = `${active} ${ACTIVE}`;
          if (pending > 0) {
            statusMessage += ` | ${pending} ${PENDING_RENEWAL}`;
          }
          if (expired > 0) {
            statusMessage += ` | ${expired} ${EXPIRED}`;
          }
        } else if (pending > 0) {
          statusMessage = `${pending}  ${PENDING_RENEWAL}`;
          if (expired > 0) {
            statusMessage += ` | ${expired} ${EXPIRED}`;
          }
        } else if (expired > 0) {
          statusMessage = `${expired} ${EXPIRED}`;
        }
        if (tasks > 0) {
          tasksMessage = `${tasks} ${tasks > 1 ? TASKS : TASK} ${PENDING}`;
        }

        return (
          <Box sx={AgentCustomTableStyles.tasksMessage}>
            <Typography sx={AgentCustomTableStyles.statusText}>
              {statusMessage}
            </Typography>
            <Typography sx={AgentCustomTableStyles.statusText}>
              {tasksMessage}
            </Typography>
          </Box>
        );
      }
      case CLAIM_STATUS: {
        const { open = 0, closed = 0 } = value;
        let statusMessage = "";

        if (open === 0 && closed === 0) {
          statusMessage = `0 ${CLAIMS}`;
        } else {
          if (open > 0 && closed > 0) {
            statusMessage = `${open} ${OPEN} | ${closed} ${CLOSED}`;
          } else if (open > 0 && closed === 0) {
            statusMessage = `${open} ${OPEN}`;
          } else if (open === 0 && closed > 0) {
            statusMessage = `${closed} ${CLOSED}`;
          } else if (open === 0 && closed === 0) {
            statusMessage = `0 ${CLAIMS}`;
          }
        }

        return (
          <Typography sx={AgentCustomTableStyles.statusText}>
            {statusMessage}
          </Typography>
        );
      }
      case COMMISSION_STATUS:
        let commissionStatusImage = "";
        let commissionStatusText = "";
        if (value.toLowerCase() === "pending") {
          commissionStatusImage = clockIcon;
          commissionStatusText = "Pending";
        } else if (value.toLowerCase() === "paid") {
          commissionStatusImage = activeIcon;
          commissionStatusText = "Paid";
        } else {
        }
        return (
          <ImageAndText
            additionalClassName={
              AgentCustomTableStyles.commissionStatusContainer
            }
            imageClassName={AgentCustomTableStyles.commissionStatusImage}
            image={commissionStatusImage}
            text={commissionStatusText}
          />
        );
      case TASK_LOWER:
        return (
          <Typography sx={AgentCustomTableStyles.tasksText}>{value}</Typography>
        );
      case COMMISSION_POLICY_DETAILS:
        return (
          <Typography sx={AgentCustomTableStyles.policyDetailsText}>
            {value}
          </Typography>
        );
      case COMMISSION_CUSTOMER_DETAILS:
        return (
          <Typography sx={AgentCustomTableStyles.customerDetailsText}>
            {value}
          </Typography>
        );
      case FOLDER_NAME:
        return (
          <ImageAndText
            imageClassName={AgentCustomTableStyles.folderImage}
            image={<CustomIcon width="24px" height="24px" iconName="Folder" />}
            text={value}
            additionalClassText={AgentCustomTableStyles.folderName}
          />
        );
      case FILE_NAME:
        return (
          <ImageAndText
            imageClassName={AgentCustomTableStyles.folderImage}
            image={
              <CustomIcon width="24px" height="24px" iconName="Document" />
            }
            text={value}
            additionalClassText={AgentCustomTableStyles.folderName}
          />
        );
      default:
        return value.length === 0 ? "----" : value;
    }
  };
  const label = { inputProps: { "aria-label": "Checkbox demo" } };

  const handleSelectAllChange = () => {
    if (checkedItems.length === data.length) {
      setCheckedItems([]);
    } else {
      setCheckedItems(data.map((_, index) => index));
    }
  };

  const handleCheckboxChange = (index: number) => {
    setCheckedItems((prevCheckedItems) => {
      if (prevCheckedItems.includes(index)) {
        return prevCheckedItems.filter((i) => i !== index);
      } else {
        return [...prevCheckedItems, index];
      }
    });
  };
  const handleToolTip = (index: any) => {
    setOpenTooltipRow(index);
  };
  const handleToolTipItem = (key: string) => {
    if (key === "notes") {
      setNotesOpen(true);
      setOpenTooltipRow(null);
      setToolTipIndex(null);
    }
    if (key === "archive") {
      setModalOpen(true);
      setOpenTooltipRow(null);
      setToolTipIndex(null);
    }
    if (key === "rescheduleTask") {
      setTasksOpen(true);

      setOpenTooltipRow(null);
      setToolTipIndex(null);
    }
    if (key === "sendRemainder") {
      setDrawerOpen(true);
    }
    if (key === "viewPolicyDetails" || key === "viewDetails") {
      navigate("/agent/policyDetails");
    }
    if (key === "view") {
      if (!isFolder) {
        navigate("/agent/documentDetails");
      }
    }
  };
  const handleNotesClick = () => {
    setNotesOpen(!notesOpen);
  };
  const handleModalClose = () => {
    setModalOpen(!modalOpen);
  };
  const handleSort = (index: number) => {
    setSortOrder((prevSortOrder) => ({
      ...prevSortOrder,
      [index]: !prevSortOrder[index],
    }));
  };
  const toggleDrawer = () => {
    setDrawerOpen(!drawerOpen);
  };
  const handleRemainderChange = (event: SelectChangeEvent) => {
    setSelectedDropdownValue(event.target.value as string);
  };
  const handleTasksClick = () => {
    setTasksOpen(!tasksOpen);
  };

  const getTableCellStyle = (styleType: string | null) => {
    let defaultStyle = AgentCustomTableStyles.tableBodyCells;
    switch (styleType) {
      case "checkbox":
        return AgentCustomTableStyles.tableBodyCheckboxCells;
      case "invoicesTable":
        return AgentCustomTableStyles.invoicesTableBodyCells;
      case "documentListingList":
        return {
          ...AgentCustomTableStyles.tableBodyLastCell,
          textAlign: "right",
        };
      case "myTasks":
        return {
          ...AgentCustomTableStyles.tableBodyLastCell,
          textAlign: "right",
        };
      default:
        return defaultStyle;
    }
  };

  const handleRowAction = (row: any) => {
    if (!row) {
      return;
    }
    let id: string | null = null;
    let lobCode: string | null = null;
    let customerId: string | null = null;
    if (requestFrom === "policyListing") {
      id = row.policyId;
      lobCode = row.lobCode;
      customerId = row.customerId;
    }

    // need to implement this for customer listing
    // if (type === "customerListing") {
    //   navigate("/agent/customer-details");
    // }
    if (id && handleRowClick) {
      handleRowClick(id, lobCode, customerId);
    }
  };

  const handleNonPayChangePage = (
    event: React.MouseEvent<HTMLButtonElement> | null,
    newPage: number
  ) => {
    setPage(newPage);
  };

  const handleChangePage = (
    event: React.MouseEvent<HTMLButtonElement> | null,
    newPage: number
  ) => {
    if (statusCode === "Non-Pay Cancelled Policies") {
      setPage(newPage);
      return;
    }
    setPage(newPage);
    if (newPage < page) {
      // Set the continuationId to preContinuationId when going back
      if (prevContinuationId !== undefined && setPrevId && setContinuationId) {
        setContinuationId(null);
        setPrevId(prevContinuationId);
      }
    } else {
      // For forward navigation (next button), set continuationId to nextContinuationId
      if (nextContinuationId !== undefined && setContinuationId) {
        setContinuationId(nextContinuationId);
      }
    }
  };

  const handleChangeRowsPerPage = (
    event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    if (statusCode === "Non-Pay Cancelled Policies") {
      setNonPayRowsPerPage(parseInt(event.target.value, 10));
      setPage(0);
    } else {
      setPoliciesPerPage(parseInt(event.target.value, 10));
      setPage(0);
      if (setContinuationId) {
        setContinuationId(null);
      }
      if (setPrevId) {
        setPrevId(null);
      }
    }
  };

  return (
    <>
      <Box 
        id="agent-custom-table-filter-container"
        data-test-id="test-agent-custom-table-filter-container"
        aria-label="Table filter container"
        sx={{ display: "flex", justifyContent: "flex-end", marginY: 2 }}
      >
        {showFilters && (
          <ImageAndText
            additionalClassName={PolicyListingStyles.filterIcon}
            onhandleClick={(event: React.MouseEvent<HTMLDivElement>) =>
              setAnchorEl(event.currentTarget)
            }
            image={filterIcon}
            text={FILTER}
          />
        )}
      </Box>
      <TableContainer
        id="agent-custom-table-container"
        data-test-id="test-agent-custom-table-container"
        aria-label="Custom table container"
        sx={Object.assign(
          {},
          AgentCustomTableStyles.tableContainer,
          additionaltableContainer
        )}
        component={Paper}
      >
        <Table>
          <TableHead sx={AgentCustomTableStyles.tableHead}>
            <TableRow>
              {primary && (
                <TableCell 
                  id="agent-custom-table-select-all-cell"
                  data-test-id="test-agent-custom-table-select-all-cell"
                  aria-label="Select all rows"
                  sx={AgentCustomTableStyles.tableHeaderCheckboxCells}
                >
                  <StyledCheckbox
                    id="agent-custom-table-select-all-checkbox"
                    data-test-id="test-agent-custom-table-select-all-checkbox"
                    aria-label="Select all rows checkbox"
                    checked={checkedItems.length === data.length}
                    onChange={handleSelectAllChange}
                    {...label}
                    color="default"
                  />
                </TableCell>
              )}

              {headers.map((header: IColumns, index: number) => {
                const defaultTheadCellCss = {
                  ...AgentCustomTableStyles.tableHeaderCells,
                  ...header.tableHeaderCells,
                };
                return (
                  <TableCell
                    id={`agent-custom-table-header-${header.label.toLowerCase().replace(/\s+/g, '-')}`}
                    data-test-id={`test-agent-custom-table-header-${header.label.toLowerCase().replace(/\s+/g, '-')}`}
                    aria-label={`Column header ${header.label}`}
                    key={`${header}_${index}`}
                    // sx={{
                    //   ...(type === "invoicesTable"
                    //     ? AgentCustomTableStyles.invoicesTableHeaderCells
                    //     : AgentCustomTableStyles.tableHeaderCells),
                    // }}
                    sx={defaultTheadCellCss}
                  >
                    <Box sx={AgentCustomTableStyles.tableHeader}>
                      <Typography 
                        id={`agent-custom-table-header-text-${header.label.toLowerCase().replace(/\s+/g, '-')}`}
                        data-test-id={`test-agent-custom-table-header-text-${header.label.toLowerCase().replace(/\s+/g, '-')}`}
                        aria-label={`Header text ${header.label}`}
                        sx={AgentCustomTableStyles.tableHeaderText}
                      >
                        {header.label}
                      </Typography>
                      {type === "invoicesTable" && (
                        <>
                          {sortOrder[index] ? (
                            <img
                              id={`agent-custom-table-sort-icon-${index}`}
                              data-test-id={`test-agent-custom-table-sort-icon-${index}`}
                              aria-label={`Sort ${header.label} column`}
                              onClick={() => handleSort(index)}
                              src={sortIcon}
                              alt={SORT_ICON}
                            />
                          ) : (
                            <img
                              id={`agent-custom-table-sort-desc-icon-${index}`}
                              data-test-id={`test-agent-custom-table-sort-desc-icon-${index}`}
                              aria-label={`Sort ${header.label} column in descending order`}
                              onClick={() => handleSort(index)}
                              src={descendingSort}
                              alt={SORT_ICON}
                            />
                          )}
                        </>
                      )}
                    </Box>
                  </TableCell>
                );
              })}
              <TableCell
                id="agent-custom-table-header-actions"
                data-test-id="test-agent-custom-table-header-actions"
                aria-label="Actions column"
                sx={AgentCustomTableStyles.tableHeaderLastCell}
              ></TableCell>
            </TableRow>
          </TableHead>

          {/* (rowsPerPage > 0
            ? rows.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
            : rows
          ) */}
          <TableBody>
            {statusCode === "Non-Pay Cancelled Policies"
              ? (nonPayRowsPerPage > 0
                  ? data.slice(
                      page * nonPayRowsPerPage,
                      page * nonPayRowsPerPage + nonPayRowsPerPage
                    )
                  : data
                ).map((row, rowIndex) => {
                  return (
                    <TableRow
                      id={`agent-custom-table-row-${rowIndex}`}
                      data-test-id={`test-agent-custom-table-row-${rowIndex}`}
                      aria-label={`Table row ${rowIndex + 1}`}
                      sx={{
                        ...AgentCustomTableStyles.tableRow,
                        ...(type !== "nohover" && {
                          ":hover": {
                            backgroundColor: "var(--greyish-blue)",
                            ...(type === "policyListing" ||
                            type === "customerListing"
                              ? { cursor: "pointer" }
                              : {}),
                          },
                        }),
                      }}
                      key={rowIndex}
                      onMouseEnter={
                        type !== "nohover" && type !== "policyListing"
                          ? () => setHoveredRow(rowIndex)
                          : undefined
                      }
                      onMouseLeave={
                        type !== "nohover" && type !== "policyListing"
                          ? () => setHoveredRow(null)
                          : undefined
                      }
                      onClick={() => handleRowAction(row)}
                    >
                      {headers.map((column: IColumns, index: number) => {
                        const defaultTbodyCellCss = {
                          ...AgentCustomTableStyles.tableBodyCells,
                          ...column.tBodyCellCss,
                        };
                        return (
                          <TableCell
                            id={`agent-custom-table-cell-${column.label.toLowerCase().replace(/\s+/g, '-')}-${rowIndex}`}
                            data-test-id={`test-agent-custom-table-cell-${column.label.toLowerCase().replace(/\s+/g, '-')}-${rowIndex}`}
                            aria-label={`${column.label} cell in row ${rowIndex + 1}`}
                            sx={defaultTbodyCellCss}
                            key={`tbody-cell-${index}`}
                          >
                            {column.Cell
                              ? column.Cell(row)
                              : column.accessorKey
                              ? row[column.accessorKey]
                              : ""}
                          </TableCell>
                        );
                      })}
                    </TableRow>
                  );
                })
              : data
                  .filter((row) => {
                    if (!showFilters) return true;
                    const selectedFilterValue = filterPopUpCommonOptions.find(
                      (option) => option.key === selectedFilter
                    )?.value;
                    return (
                      selectedFilter === "all" ||
                      !selectedFilter ||
                      row.cancelRequestedByCd === selectedFilterValue
                    );
                  })
                  .map((row, rowIndex) => {
                    return (
                      <TableRow
                        id={`agent-custom-table-row-${rowIndex}`}
                        data-test-id={`test-agent-custom-table-row-${rowIndex}`}
                        aria-label={`Table row ${rowIndex + 1}`}
                        sx={{
                          ...AgentCustomTableStyles.tableRow,
                          ...(type !== "nohover" && {
                            ":hover": {
                              backgroundColor: "var(--greyish-blue)",
                              ...(type === "policyListing" ||
                              type === "customerListing"
                                ? { cursor: "pointer" }
                                : {}),
                            },
                          }),
                        }}
                        key={rowIndex}
                        onMouseEnter={
                          type !== "nohover" && type !== "policyListing"
                            ? () => setHoveredRow(rowIndex)
                            : undefined
                        }
                        onMouseLeave={
                          type !== "nohover" && type !== "policyListing"
                            ? () => setHoveredRow(null)
                            : undefined
                        }
                        onClick={() => handleRowAction(row)}
                      >
                        {headers.map((column: IColumns, index: number) => {
                          const defaultTbodyCellCss = {
                            ...AgentCustomTableStyles.tableBodyCells,
                            ...column.tBodyCellCss,
                          };
                          return (
                            <TableCell
                              id={`agent-custom-table-cell-${column.label.toLowerCase().replace(/\s+/g, '-')}-${rowIndex}`}
                              data-test-id={`test-agent-custom-table-cell-${column.label.toLowerCase().replace(/\s+/g, '-')}-${rowIndex}`}
                              aria-label={`${column.label} cell in row ${rowIndex + 1}`}
                              sx={defaultTbodyCellCss}
                              key={`tbody-cell-${index}`}
                            >
                              {column.Cell
                                ? column.Cell(row)
                                : column.accessorKey
                                ? row[column.accessorKey]
                                : ""}
                            </TableCell>
                          );
                        })}
                      </TableRow>
                    );
                  })}
          </TableBody>
        </Table>
      </TableContainer>
      {/* {statusCode === "Non-Pay Cancelled Policies" ? (
        <TablePagination
          rowsPerPageOptions={rowsPerPageOptions}
          component="div"
          count={data?.length}
          rowsPerPage={nonPayRowsPerPage}
          page={page}
          onPageChange={handleNonPayChangePage}
          onRowsPerPageChange={handleChangeRowsPerPage}
        />
      ) : (
        <TablePagination
          rowsPerPageOptions={rowsPerPageOptions}
          component="div"
          count={Number(totalPolicies)}
          rowsPerPage={Number(policiesPerPage)}
          page={page}
          onPageChange={handleChangePage}
          onRowsPerPageChange={handleChangeRowsPerPage}
          slotProps={{
            actions: {
              previousButton: {
                disabled:
                  (prevContinuationId === null &&
                    currentContinuationId === null) ||
                  (prevContinuationId === "" && currentContinuationId !== ""),
              },
              nextButton: {
                disabled:
                  nextContinuationId === null || nextContinuationId === "",
              },
            },
          }}
        />
      )} */}
      <Drawers open={notesOpen} toggleDrawer={handleNotesClick} heading={NOTES}>
        <Notes personDataArray={personData} personChatArray={personChat} />
      </Drawers>
      <ModalComponent
        headingAdditionalClass={AgentCustomTableStyles.modalHeading}
        heading={
          isFolder
            ? ARE_YOU_SURE_ARCHIVE + `"${fileName}"` + FOLDER_LOWER
            : ARCHIVE_FILE
        }
        open={modalOpen}
        handleOpen={handleModalClose}
        additionalClassContainer={AgentCustomTableStyles.modalContainer}
        headingContainerAdditionalClass={
          AgentCustomTableStyles.modalHeadingContainer
        }
      >
        <Box 
          id="agent-custom-table-archive-content"
          data-test-id="test-agent-custom-table-archive-content"
          aria-label="Archive confirmation content"
          sx={AgentCustomTableStyles.contentContainer}
        >
          <ImageAndText
            image={<CustomIcon iconName="Archive" />}
            text={
              isFolder
                ? ARCHIVING_THE_FOLDER
                : ARE_YOU_SURE_ARCHIVE + `"${fileName}"` + FILE_LOWER
            }
            additionalClassText={AgentCustomTableStyles.imageText}
          />
          <Box 
            id="agent-custom-table-archive-buttons"
            data-test-id="test-agent-custom-table-archive-buttons"
            aria-label="Archive action buttons"
            sx={AgentCustomTableStyles.buttonsContainer}
          >
            <CustomButton
              text={"Confirm"}
              additionalClassName={AgentCustomTableStyles.cancelButton}
            />
            <CustomButton
              onHandleClick={handleModalClose}
              text={CANCEL}
              type="outlined"
              additionalClassName={AgentCustomTableStyles.cancelButton}
            />
          </Box>
        </Box>
      </ModalComponent>
      <Drawers
        open={drawerOpen}
        toggleDrawer={toggleDrawer}
        heading={"Send Reminder"}
      >
        <SendRemainder
          recieverName={sendRemaindersAndShareMarketData.recieverName}
          dropDownData={sendRemaindersAndShareMarketData.dropdownData}
          fileUploadName={sendRemaindersAndShareMarketData.fileUploadName}
          fileUploadSize={sendRemaindersAndShareMarketData.fileUploadSize}
          handleRemainderChange={handleRemainderChange}
          selectedDropdownValue={selectedDropdownValue}
          onCancelClick={toggleDrawer}
        />
      </Drawers>
      <Drawers
        additionalClass={AgentCustomTableStyles.drawer}
        open={tasksOpen}
        toggleDrawer={handleTasksClick}
        heading={ADD_TASK}
      >
        <NewTask onCancelClick={handleTasksClick} />
      </Drawers>
      <FilterPopUp
        options={filterPopUpCommonOptions}
        selectedKey={selectedFilter}
        onSelect={handleSelect}
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
      />
    </>
  );
};

export default AgentCustomTable;
